<ng-container *transloco="let t">
  @if (page.servicesSection) {
    <bgo-services-section
      [servicesSection]="page.servicesSection"
      [showAllServicesButton]="false"
      itemsElevation="elevated"
      [itemsSeparator]="false"
      itemsCallToActionAppearance="link"
      class="h-layout pt-2xl pb-3xl"
    >
    </bgo-services-section>
  }
  <bgo-support-section class="pt-2xl" [supportSection]="page.supportSection" layout="h-layout" />
  @if (page.partnerSection) {
    <cft-partners class="h-layout pt-2xl pb-3xl" [section]="page.partnerSection"></cft-partners>
  }
</ng-container>
